export const HOME = "Home";
export const MEMBER_EXCLUSIVES = "Member exclusives";
export const MY_REWARDS = "My Rewards";
export const ABOUT_US_FAQ = "About us / FAQ";
export const CONTACT_US = "Contact us";
export const PHARMACY_LOCATOR = "Pharmacy locator";
export const SIGN_OUT = "Sign Out";
